import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { UserService } from './user.service';

@Injectable()
export class SentryService {

  private envName: string = null;

  constructor(private userService: UserService) { }

  /**
   * Initialize the service - gets called from APP_INITIALIZER because services don't have ngOnInit
   * @param dsn
   * @param envName
   */
  init(dsn: string, envName: string) {
    this.envName = envName;

    Sentry.init({
      dsn: dsn,
      environment: envName
    });
  }

  /**
   * Configure user information if they are logged in
   */
  identify() {
    this.userService.getProfile().subscribe(
      (result: any) => {
        Sentry.configureScope((scope) => {
          scope.setUser({
            ...result,
            email: result.email_address
          });
        });
      },
      (err) => { });
  }

  /**
   * Log error in Sentry siftrock-app
   * @param error
   */
  error(error: Error) {
    if (this.envName !== 'development') {
      Sentry.captureException(error);
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/services/sentry.service.ts